import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

function sortByIds(ids: string[], products: UnlikelyProduct[]) {
  return ids.map((id) => products.find((product) => product.id === id)).filter(Boolean)
}

export { sortByIds }
